const oidcConfig = {
    authority: process.env.REACT_APP_AUTH_API_ADDRESS ?? '',
    client_id: process.env.REACT_APP_CLIENT_ID ?? '',
    redirect_uri: process.env.REACT_APP_REDIRECT_URI ?? '',
    post_logout_redirect_uri: process.env.REACT_APP_LOGOUT_REDIRECT_URI ?? '',
    scope: process.env.REACT_APP_SCOPES
};

export default oidcConfig;